import { css } from 'emotion'

export const DisplayNameSpanStyles = css``
